const BNPL_CURRENCY_USD = 'USD';

const CHECKOUT_FLOW_VARIANT = {
    DESKTOP: 'desktop',
    MOBILE_STEPPED: 'mobile_stepped',
    MOBILE_SINGLE: 'mobile_single',
};

const PLATFORM = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};

const BNPL_SELECTED_OPTION = {
    PAY_NOW: 'pay_now',
    PAY_LATER: 'pay_later',
};

const BNPL_DISABLED_REASON = {
    FULLY_COVERED_BY_POINTS: 'fully_covered_by_points',
    DEADLINE_TOO_CLOSE: 'deadline_too_close',
};

module.exports = {
    BNPL_CURRENCY_USD,
    CHECKOUT_FLOW_VARIANT,
    PLATFORM,
    BNPL_SELECTED_OPTION,
    BNPL_DISABLED_REASON,
};
